import { muiGlyph } from "@/components/ui/mui-glyph";

// The glyphs the donor's text fields draw inside or over their outline.
//
// Each is an `@mui/icons-material` import (the calendar excepted — see its own
// note) at its default `fontSize: medium`, a
// 24px box (`SvgIcon.js:75-78`): `Search` in the items search box's start
// adornment (`items-searchbox.tsx:7,72`), and `Check` on the confirm
// `IconButton` the lookup menus lay over their inline add and rename fields
// (`AddOptionButton.tsx:81`, `EditableOption.tsx:91`). The clear cross the
// search box also draws is `Clear`, already ported as `MuiClearIcon` for the
// items toolbar.
//
// Atlas drew lucide's `Search` and `Check`: stroked outlines where MUI's are
// solid fills, a different drawing of the same idea (#576's parity review
// measured the magnifier's ink at 17x16 against lucide's 20x19). Paths copied
// byte-for-byte from `timmy/node_modules/@mui/icons-material` (9.2.0).

/** `@mui/icons-material/Search.js`. */
const SEARCH_PATH =
  "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14";
/** `@mui/icons-material/Check.js`. */
const CHECK_PATH = "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z";

/**
 * `@mui/x-date-pickers/icons` `CalendarIcon` — the date field's open-picker
 * button (`PickerFieldUI.mjs:124-138`), at the `IconButton`'s medium 24px.
 * The pickers ship their own copy of the glyph rather than importing
 * `@mui/icons-material`, so the path is theirs byte for byte (9.4.0).
 */
const CALENDAR_PATH =
  "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z";

export const MuiSearchIcon = muiGlyph("mui-search", SEARCH_PATH, "size-6");
export const MuiCheckIcon = muiGlyph("mui-check", CHECK_PATH, "size-6");
export const MuiCalendarIcon = muiGlyph("mui-calendar", CALENDAR_PATH, "size-6");
